var map = {
	"./1.jpg": "Zx2f",
	"./2.jpg": "hH1z",
	"./3.jpg": "lpm5",
	"./4.jpg": "Snxm",
	"./5.jpg": "fQvg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RnJH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar ^\.\/.*\.jpg$
// module id = RnJH
// module chunks = 1 2